<template>
  <button
    class="search-result-item"
    :class="{ 'warning-acupuncture': isThreeAcupuncture }"
    @click="updateList"
  >
    <div class="icon-container">
      <i v-if="isChecked" class="ii ii-check-circle"></i>
      <i v-else class="ii ii-check-circle-outline"></i>
      <span v-if="isThreeAcupuncture" class="warning-acupuncture-desc"
        >침술 3종</span
      >
    </div>

    <div class="item-border-box hospital-type-container">
      <div class="hospital-type">
        <span>{{
          item.hospitalForm === '00'
            ? '한의원'
            : item.isFarm
            ? '한병(읍)'
            : '한병(동)'
        }}</span>
        <span v-if="item.isSenior !== null">{{
          item.isSenior ? '65세 이상' : '65세 미만'
        }}</span>
        <span>{{ convertToCode(item.patientForm) }}</span>

        <span>{{
          item.clinicHours === null
            ? '평일'
            : item.clinicHours === '03'
            ? '토요'
            : '야간'
        }}</span>
        <span v-if="item.dialecticSkillFee">{{
          item.dialecticSkillFee && '변증'
        }}</span>
      </div>
      <div>
        <span class="hospital-type-title">본부금</span>
        <span class="hospital-type-value">{{
          threeDigitComma(item.copay)
        }}</span>
      </div>
      <div>
        <span class="hospital-type-title">총 진료비</span>
        <span class="hospital-type-value">{{
          threeDigitComma(item.totalPay)
        }}</span>
      </div>
    </div>

    <div class="item-border-box type-of-acupuncture-container">
      <h2 class="item-title">침술 종류</h2>
      <span class="item-list">{{ returnAcupuncture() }}</span>
    </div>
    <div class="item-border-box type-of-treatment-container">
      <h2 class="item-title">치료 종류</h2>
      <span class="item-list">{{ returnTypeOfTreatment() }}</span>
    </div>
    <div class="item-border-box nonbenefit-container">
      <h2 class="item-title">비급여</h2>
      <span class="item-list">{{ threeDigitComma(item.nonbenefitPay) }}</span>
    </div>
    <div class="item-border-box herb-container">
      <h2 class="item-title">원내비치 한약제제</h2>
      <span class="item-list">{{ returnHerb() }}</span>
    </div>

    <div class="item-border-box number-of-prescription-days-container">
      <h2 class="item-title">처방 일 수</h2>
      <span class="item-list">{{ convertToCode(item.prescriptionDays) }}</span>
    </div>

    <div class="item-border-box inspection-type-container">
      <h2 class="item-title">검사</h2>
      <span class="item-list">{{
        item.inspectionType ? convertToCode(item.inspectionType) : ''
      }}</span>
    </div>
  </button>
</template>

<script>
export default {
  name: 'search-result-item',
  props: {
    item: {
      type: Object,
      required: true,
    },
    selectedList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isChecked: false,
      numberCode: {
        '00': '한의원',
        '101': '초',
        '102': '재',
        '03': '토요일 9~13시',
        '01': '야간/공휴일',
        '40011': '1부위',
        '40012': '2부위',
        '2': '자락/도침/산침',
        '4': '사암/오행/체질',
        '6': '화침/온침',
        '40080': '투자',
        '40070': '척추',
        '40060': '관절',
        '40050': '복강',
        '40040': '비강',
        '40030': '안와',
        '40091': '침전기자극술',
        '40307': '기기구술',
        '40305': '반흔구',
        '40306': '간접 애주구',
        '40304': '직접 애주구',
        '40321': '유관법',
        '40322': '섬관법',
        '40323': '주관법',
        '40312': '자락관법',
        '40313': '자락관법 (2부위)',
        '40701': '경피적외선조사요법',
        '40700': '경피경근온열요법',
        '40702': '경피경근한냉요법',
        '40710': '단순 추나',
        '40720': '복잡 추나(본인 부담(50%))',
        '40721': '복잡 추나(본인 부담(80%))',
        '40400': '변증기술료',
        '30010': '1일',
        '30020': '2일',
        '30030': '3일',
        '30040': '4일',
        '30050': '5일',
        '30060': '6일',
        '30070': '7일',
        '20020': '맥전도',
        '20010': '양도락',
        '20030': '경락기능',
        '20031': '양명경',
        '20032': '수양명경',
        '20023': '3D맥영상', // MARK: 2024년도 수가에 추가된 항목입니다.
      },
    };
  },
  computed: {
    isThreeAcupuncture() {
      // MARK : 침술이 3종 들어간 경우 경고 메시지를 띄워주기 위해 구분한다.
      // 아래 상황의 경우에 3종으로 분류된다.
      if (this.item.acupunctureSpecial === null) {
        // MARK: 예전에 담아둔 조합에 특수침술이 null인 경우 (현재는 null로 들어오지않는다.)
        return false;
      }
      // 1. 부가 침술이 사암/오행/체질이면서 특수 침술이 하나라도 포함된 경우
      const _acupunctureSpecial = this.item.acupunctureSpecial.filter(v => v);
      if (
        this.item.acupunctureAdditional === '4' &&
        _acupunctureSpecial.length > 0
      ) {
        return true;
      }
      // 2 경혈 침술을 선택했고 부가 침술이 사암/오행이 아니면서 특수 침술이 2개 이상 포함된 경우
      if (
        this.item.acupunctureGeneral &&
        this.item.acupunctureAdditional !== '4' &&
        _acupunctureSpecial.length >= 2
      ) {
        return true;
      }

      // 3. 부가 침술이 자락/도침/산침, 화침/온침이면서 특수 침술이 2개 이상 포함된 경우
      return this.item.acupunctureAdditional && _acupunctureSpecial.length >= 2;
    },
  },
  watch: {
    selectedList: {
      handler() {
        const selectedList = this.selectedList;
        const currentId = this.item?.id;
        this.isChecked = selectedList.some(({ id }) => id === currentId);
      },
      immediate: true,
    },
  },
  methods: {
    updateList() {
      this.$emit('update-list', this.item);
    },
    threeDigitComma(price) {
      if (Number.isNaN(price) || price === null || price === undefined) {
        return null;
      }

      return Math.round(Number(price)).toLocaleString();
    },
    returnAcupuncture() {
      const convertToCode = list => {
        if (!list) return;
        return list
          .filter(item => item)
          .map(item => (this.numberCode[item] ? this.numberCode[item] : item))
          .join(', ');
      };
      const mainAcupuncture = this.item.acupunctureGeneral
        ? `경혈 ${this.numberCode[this.item.acupunctureGeneral]}`
        : null;
      const subAcupuncture = this.item.acupunctureAdditional
        ? `(${this.numberCode[this.item.acupunctureAdditional]})`
        : null;

      const mainSubAcupuncture = convertToCode([
        mainAcupuncture,
        subAcupuncture,
      ]);
      const _acupunctureSpecial = convertToCode(this.item.acupunctureSpecial);
      const _acupunctureElectrical = this.item.acupunctureElectrical
        ? this.numberCode[this.item.acupunctureElectrical]
        : null;
      const acupunctureTypes = [
        mainSubAcupuncture,
        _acupunctureSpecial,
        _acupunctureElectrical,
      ];
      const _acupunctureTypes = convertToCode(acupunctureTypes);
      return _acupunctureTypes;
    },
    returnTypeOfTreatment() {
      const hasCupping = this.item.cupping;

      const typeOfTreatment = [
        this.item.moxibustion,
        this.item.physicalTherapy,
        this.item.chunaTherapy,
      ]
        .filter(item => item)
        .map(item => this.numberCode[item])
        .join(', ');

      if (hasCupping) {
        return typeOfTreatment.length
          ? [
              typeOfTreatment,
              `${this.numberCode[this.item.cupping]}(부항컵 ${
                this.item.cuppingCup.count
              })`,
            ].join(', ')
          : `${this.numberCode[this.item.cupping]}(부항컵 ${
              this.item.cuppingCup.count
            })`;
      }
      return typeOfTreatment;
    },
    returnHerb() {
      const { name, pay } = this.item.herb;
      if (name && pay) {
        return `${name} (${this.threeDigitComma(pay)}원)`;
      }
      return '';
    },

    convertToCode(code) {
      return this.numberCode[code];
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-container {
  position: relative;
}
.warning-acupuncture {
  border: 1px solid #e64937 !important;
}
.warning-acupuncture-desc {
  position: absolute;
  left: 0.75rem;
  top: 2rem;
  font-size: 0.5625rem;
  color: #e64937;
  white-space: nowrap;
}
.ii-check-circle-outline {
  font-size: 1.625rem;
  padding-left: 0.75rem;
  padding-top: 0.5rem;
  color: #d4d7df;
}
.ii-check-circle {
  font-size: 1.625rem;
  color: #1066e9;
  padding-left: 0.75rem;
  padding-top: 0.5rem;
}
.search-result-item {
  display: flex;
  height: 7.25rem;
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 0.625rem;
  margin-bottom: 0.625rem;
}
.item-border-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  border-right: 1px solid #e1e4ec;
  padding: 1rem;
  .item-title {
    font-size: 0.625rem;
    color: #b5b7bf;
  }
  .item-list {
    font-size: 0.6875rem;
    text-align: left;
  }
}
.item-border-box:last-child {
  border-right: none;
}
.hospital-type {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-bottom: 0.125rem;
  span {
    font-size: 0.625rem;
    color: #94969d;
    margin-right: 0.25rem;
    padding: 0.25rem;
    border-radius: 0.25rem;
    background: #f1f3f8;
  }
}
.hospital-type-title {
  display: inline-block;
  text-align: left;
  width: 4.375rem;
  font-size: 0.9375rem;
  margin-top: 0.5rem;
}
.hospital-type-value {
  font-size: 0.9375rem;
  font-weight: 600;
}

.hospital-type-container {
  width: 12.25rem;
}
.type-of-acupuncture-container,
.type-of-treatment-container,
.herb-container {
  width: 7.625rem;
}
.nonbenefit-container {
  width: 4.875rem;
}
.number-of-prescription-days-container,
.inspection-type-container {
  width: 5.125rem !important;
}
</style>
